import { addLocaleData } from 'react-intl';
import nl from 'react-intl/locale-data/nl';

import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';
import navNl from '@99designs/common/apps/global-nav/locale-data/nl';

setNavTranslations(navNl);
addLocaleData(nl);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/nl.js